import { render, staticRenderFns } from "./DownCode.vue?vue&type=template&id=0512547a&"
import script from "./DownCode.vue?vue&type=script&lang=js&"
export * from "./DownCode.vue?vue&type=script&lang=js&"
import style0 from "./DownCode.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports